import React from 'react'
import { UseQueryResult, useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import { Role } from '../../types'
import RefreshButton from '../../components/RefreshButton'
import { fetchRoles } from '../../api/API'
import {
  Alert,
  AlertTitle,
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
} from '@mui/material'
import { StyledTableRow, StyledTableCell } from '../../components/EnchancedTable'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const RolesList: React.FC = () => {
  const history = useHistory()
  const roles: UseQueryResult<Role[]> = useQuery(['roles'], () => fetchRoles(0, 100, 'name'))

  const handleRowClick = (roleId: string) => {
    history.push(`/roles/${roleId}`)
  }

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" color="primary">
          Roles
        </Typography>
        <RefreshButton loading={roles.isFetching} refresh={roles.refetch} />
      </Box>

      <Box>
        {roles.error ? (
          <Alert severity="error">
            <>
              <AlertTitle>Error fetching Roles</AlertTitle>
              {roles.error}
            </>
          </Alert>
        ) : (
          <Paper sx={{ width: '100%', mb: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell align="right">Application Permissions</StyledTableCell>
                    <StyledTableCell align="right">Data Permissions</StyledTableCell>
                    <StyledTableCell align="right">Global Permissions</StyledTableCell>
                    <StyledTableCell align="right"></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {roles.data?.map((role) => (
                    <StyledTableRow
                      key={role.referenceId}
                      onClick={() => handleRowClick(role.referenceId)}
                      hover
                      sx={{ cursor: 'pointer' }}
                    >
                      <StyledTableCell>{role.name}</StyledTableCell>
                      <StyledTableCell align="right">{role.applicationPermissions.length}</StyledTableCell>
                      <StyledTableCell align="right">{role.dataPermissions.length}</StyledTableCell>
                      <StyledTableCell align="right">{role.globalPermissions.length}</StyledTableCell>
                      <StyledTableCell align="right">
                        <IconButton size="small">
                          <ChevronRightIcon />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>
    </Box>
  )
}

export default RolesList
